/**
 * Program exercises (client) – list by program (read-only).
 */
import { collection, getDocs, query, where, orderBy } from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION = 'programExercises';

export function programExerciseRepository({ getFirestore = () => db } = {}) {
  const firestore = getFirestore();
  const coll = () => collection(firestore, COLLECTION);

  return {
    async listByProgram(programId) {
      const q = query(
        coll(),
        where('programId', '==', programId),
        orderBy('weekNumber', 'asc'),
        orderBy('order', 'asc')
      );
      const snap = await getDocs(q);
      return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    },
  };
}

export const programExerciseRepo = programExerciseRepository();
